/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateStakeholderDto } from '../models';
// @ts-ignore
import type { DoubleMaterialityStakeholdersControllerGetAllStakeholders200Response } from '../models';
// @ts-ignore
import type { ImportStakeholdersDto } from '../models';
// @ts-ignore
import type { StakeholderDto } from '../models';
// @ts-ignore
import type { StakeholderPublicInfoDto } from '../models';
// @ts-ignore
import type { UpdateStakeholderDto } from '../models';
/**
 * DoubleMaterialityStakeholdersApi - axios parameter creator
 * @export
 */
export const DoubleMaterialityStakeholdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateStakeholderDto} createStakeholderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerCreateStakeholder: async (createStakeholderDto: CreateStakeholderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createStakeholderDto' is not null or undefined
            assertParamExists('doubleMaterialityStakeholdersControllerCreateStakeholder', 'createStakeholderDto', createStakeholderDto)
            const localVarPath = `/api/dm/stakeholders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStakeholderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerDeleteStakeholder: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityStakeholdersControllerDeleteStakeholder', 'id', id)
            const localVarPath = `/api/dm/stakeholders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} year Reporting year for the double materiality data
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerGetAllStakeholders: async (year: number, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('doubleMaterialityStakeholdersControllerGetAllStakeholders', 'year', year)
            const localVarPath = `/api/dm/stakeholders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerGetStakeholderById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityStakeholdersControllerGetStakeholderById', 'id', id)
            const localVarPath = `/api/dm/stakeholders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerGetStakeholderPublicInfo: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityStakeholdersControllerGetStakeholderPublicInfo', 'id', id)
            const localVarPath = `/api/dm/stakeholders/public/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportStakeholdersDto} importStakeholdersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerImportStakeholders: async (importStakeholdersDto: ImportStakeholdersDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importStakeholdersDto' is not null or undefined
            assertParamExists('doubleMaterialityStakeholdersControllerImportStakeholders', 'importStakeholdersDto', importStakeholdersDto)
            const localVarPath = `/api/dm/stakeholders/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importStakeholdersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerSubmitSurvey: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityStakeholdersControllerSubmitSurvey', 'id', id)
            const localVarPath = `/api/dm/stakeholders/public/{id}/submit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateStakeholderDto} updateStakeholderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerUpdateStakeholder: async (id: string, updateStakeholderDto: UpdateStakeholderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityStakeholdersControllerUpdateStakeholder', 'id', id)
            // verify required parameter 'updateStakeholderDto' is not null or undefined
            assertParamExists('doubleMaterialityStakeholdersControllerUpdateStakeholder', 'updateStakeholderDto', updateStakeholderDto)
            const localVarPath = `/api/dm/stakeholders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStakeholderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerUpdateSurveyComment: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityStakeholdersControllerUpdateSurveyComment', 'id', id)
            const localVarPath = `/api/dm/stakeholders/public/{id}/comment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DoubleMaterialityStakeholdersApi - functional programming interface
 * @export
 */
export const DoubleMaterialityStakeholdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DoubleMaterialityStakeholdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateStakeholderDto} createStakeholderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityStakeholdersControllerCreateStakeholder(createStakeholderDto: CreateStakeholderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StakeholderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityStakeholdersControllerCreateStakeholder(createStakeholderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityStakeholdersApi.doubleMaterialityStakeholdersControllerCreateStakeholder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityStakeholdersControllerDeleteStakeholder(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityStakeholdersControllerDeleteStakeholder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityStakeholdersApi.doubleMaterialityStakeholdersControllerDeleteStakeholder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} year Reporting year for the double materiality data
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityStakeholdersControllerGetAllStakeholders(year: number, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoubleMaterialityStakeholdersControllerGetAllStakeholders200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityStakeholdersControllerGetAllStakeholders(year, search, orderBy, orderDirection, pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityStakeholdersApi.doubleMaterialityStakeholdersControllerGetAllStakeholders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityStakeholdersControllerGetStakeholderById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StakeholderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityStakeholdersControllerGetStakeholderById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityStakeholdersApi.doubleMaterialityStakeholdersControllerGetStakeholderById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityStakeholdersControllerGetStakeholderPublicInfo(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StakeholderPublicInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityStakeholdersControllerGetStakeholderPublicInfo(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityStakeholdersApi.doubleMaterialityStakeholdersControllerGetStakeholderPublicInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ImportStakeholdersDto} importStakeholdersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityStakeholdersControllerImportStakeholders(importStakeholdersDto: ImportStakeholdersDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StakeholderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityStakeholdersControllerImportStakeholders(importStakeholdersDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityStakeholdersApi.doubleMaterialityStakeholdersControllerImportStakeholders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityStakeholdersControllerSubmitSurvey(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityStakeholdersControllerSubmitSurvey(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityStakeholdersApi.doubleMaterialityStakeholdersControllerSubmitSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateStakeholderDto} updateStakeholderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityStakeholdersControllerUpdateStakeholder(id: string, updateStakeholderDto: UpdateStakeholderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StakeholderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityStakeholdersControllerUpdateStakeholder(id, updateStakeholderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityStakeholdersApi.doubleMaterialityStakeholdersControllerUpdateStakeholder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityStakeholdersControllerUpdateSurveyComment(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityStakeholdersControllerUpdateSurveyComment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityStakeholdersApi.doubleMaterialityStakeholdersControllerUpdateSurveyComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DoubleMaterialityStakeholdersApi - factory interface
 * @export
 */
export const DoubleMaterialityStakeholdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DoubleMaterialityStakeholdersApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateStakeholderDto} createStakeholderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerCreateStakeholder(createStakeholderDto: CreateStakeholderDto, options?: RawAxiosRequestConfig): AxiosPromise<StakeholderDto> {
            return localVarFp.doubleMaterialityStakeholdersControllerCreateStakeholder(createStakeholderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerDeleteStakeholder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.doubleMaterialityStakeholdersControllerDeleteStakeholder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} year Reporting year for the double materiality data
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerGetAllStakeholders(year: number, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<DoubleMaterialityStakeholdersControllerGetAllStakeholders200Response> {
            return localVarFp.doubleMaterialityStakeholdersControllerGetAllStakeholders(year, search, orderBy, orderDirection, pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerGetStakeholderById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StakeholderDto> {
            return localVarFp.doubleMaterialityStakeholdersControllerGetStakeholderById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerGetStakeholderPublicInfo(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StakeholderPublicInfoDto> {
            return localVarFp.doubleMaterialityStakeholdersControllerGetStakeholderPublicInfo(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ImportStakeholdersDto} importStakeholdersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerImportStakeholders(importStakeholdersDto: ImportStakeholdersDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<StakeholderDto>> {
            return localVarFp.doubleMaterialityStakeholdersControllerImportStakeholders(importStakeholdersDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerSubmitSurvey(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.doubleMaterialityStakeholdersControllerSubmitSurvey(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateStakeholderDto} updateStakeholderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerUpdateStakeholder(id: string, updateStakeholderDto: UpdateStakeholderDto, options?: RawAxiosRequestConfig): AxiosPromise<StakeholderDto> {
            return localVarFp.doubleMaterialityStakeholdersControllerUpdateStakeholder(id, updateStakeholderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityStakeholdersControllerUpdateSurveyComment(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.doubleMaterialityStakeholdersControllerUpdateSurveyComment(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DoubleMaterialityStakeholdersApi - object-oriented interface
 * @export
 * @class DoubleMaterialityStakeholdersApi
 * @extends {BaseAPI}
 */
export class DoubleMaterialityStakeholdersApi extends BaseAPI {
    /**
     * 
     * @param {CreateStakeholderDto} createStakeholderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityStakeholdersApi
     */
    public doubleMaterialityStakeholdersControllerCreateStakeholder(createStakeholderDto: CreateStakeholderDto, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityStakeholdersApiFp(this.configuration).doubleMaterialityStakeholdersControllerCreateStakeholder(createStakeholderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityStakeholdersApi
     */
    public doubleMaterialityStakeholdersControllerDeleteStakeholder(id: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityStakeholdersApiFp(this.configuration).doubleMaterialityStakeholdersControllerDeleteStakeholder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} year Reporting year for the double materiality data
     * @param {string | null} [search] 
     * @param {string | null} [orderBy] 
     * @param {string | null} [orderDirection] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityStakeholdersApi
     */
    public doubleMaterialityStakeholdersControllerGetAllStakeholders(year: number, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityStakeholdersApiFp(this.configuration).doubleMaterialityStakeholdersControllerGetAllStakeholders(year, search, orderBy, orderDirection, pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityStakeholdersApi
     */
    public doubleMaterialityStakeholdersControllerGetStakeholderById(id: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityStakeholdersApiFp(this.configuration).doubleMaterialityStakeholdersControllerGetStakeholderById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityStakeholdersApi
     */
    public doubleMaterialityStakeholdersControllerGetStakeholderPublicInfo(id: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityStakeholdersApiFp(this.configuration).doubleMaterialityStakeholdersControllerGetStakeholderPublicInfo(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ImportStakeholdersDto} importStakeholdersDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityStakeholdersApi
     */
    public doubleMaterialityStakeholdersControllerImportStakeholders(importStakeholdersDto: ImportStakeholdersDto, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityStakeholdersApiFp(this.configuration).doubleMaterialityStakeholdersControllerImportStakeholders(importStakeholdersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityStakeholdersApi
     */
    public doubleMaterialityStakeholdersControllerSubmitSurvey(id: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityStakeholdersApiFp(this.configuration).doubleMaterialityStakeholdersControllerSubmitSurvey(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateStakeholderDto} updateStakeholderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityStakeholdersApi
     */
    public doubleMaterialityStakeholdersControllerUpdateStakeholder(id: string, updateStakeholderDto: UpdateStakeholderDto, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityStakeholdersApiFp(this.configuration).doubleMaterialityStakeholdersControllerUpdateStakeholder(id, updateStakeholderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityStakeholdersApi
     */
    public doubleMaterialityStakeholdersControllerUpdateSurveyComment(id: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityStakeholdersApiFp(this.configuration).doubleMaterialityStakeholdersControllerUpdateSurveyComment(id, options).then((request) => request(this.axios, this.basePath));
    }
}

